// AddRoleForm.js
import React, { useState } from "react";
import "./AddUserForm.css"; // Reuse the same styling

const AddRoleForm = ({ onClose, onRoleAdded }) => {
  const [formData, setFormData] = useState({
    role_name: "",
    description: "",
  });

  const [error, setError] = useState(null);

  // Handle input changes
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.role_name) {
      setError("Role Name is required.");
      return;
    }

    try {
      const response = await fetch("/api/add-role", {
        method: "POST", // 🔁 POST API corresponding to the same base path as GET /api/roles
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed to add role.");
      }

      alert("✅ Role added successfully!");
      setTimeout(() => {
        if (onRoleAdded) onRoleAdded(); // Refresh role list in parent
        onClose(); // Close modal
      }, 300);
    } catch (err) {
      console.error("❌ Error adding role:", err.message);
      setError(err.message || "An error occurred.");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        {/* Close Button */}
        <button className="close-button" onClick={onClose}>
          ✖
        </button>

        <h3>Add Role</h3>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label id="add-user-label">Role Name:</label>
            <input
              id="add-user-input"
              type="text"
              name="role_name"
              value={formData.role_name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label id="add-user-label">Description:</label>
            <textarea
              id="add-user-input"
              name="description"
              value={formData.description}
              onChange={handleChange}
              rows={3}
            />
          </div>

          {/* Display error message */}
          {error && <p className="error-message">{error}</p>}

          <button type="submit" className="submit-btn">
            Add Role
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddRoleForm;
